import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Apertura2007 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 478; i <= 497; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
	kit_path: '/images/kits/todas/',
      kits: [],
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,

	table2:[{'color':0,'shortname':'cobreloa', 'rivalName':'Cobreloa', 'pj':20, 'pg':10,'pe':5,'pp':5,'gf':44,'gc':23,'dif':21, 'pts':35},
              {'color':'#295e1e','shortname':'audax', 'rivalName':'Audax Italiano', 'pj':20, 'pg':13,'pe':5,'pp':2,'gf':39,'gc':20,'dif':19, 'pts':44},
	     {'color':0,'shortname':'concepcion', 'rivalName':'Dep. Concepción', 'pj':20, 'pg':6,'pe':5,'pp':9,'gf':20,'gc':34,'dif':-14, 'pts':23},
              {'color':0,'shortname':'puertomontt', 'rivalName':'Puerto Montt', 'pj':20, 'pg':4,'pe':2,'pp':14,'gf':19,'gc':40,'dif':-21, 'pts':14},
	      {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':20, 'pg':4,'pe':5,'pp':11,'gf':25,'gc':33,'dif':-8, 'pts':17},
              {'color':'#295e1e','shortname':'catolica', 'rivalName':'U. Católica', 'pj':20, 'pg':14,'pe':4,'pp':2,'gf':36,'gc':14,'dif':22, 'pts':46},
              {'color':'#135683','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':20, 'pg':14,'pe':5,'pp':1,'gf':47,'gc':16,'dif':31, 'pts':47},
              {'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pj':20, 'pg':9,'pe':5,'pp':6,'gf':31,'gc':21,'dif':10, 'pts':32},
              {'color':'#295e1e','shortname':'huachipato', 'rivalName':'Huachipato', 'pj':20, 'pg':12,'pe':4,'pp':4,'gf':35,'gc':21,'dif':14, 'pts':40},
              {'color':0,'shortname':'udechile', 'rivalName':'U. de Chile', 'pj':20, 'pg':6,'pe':7,'pp':7,'gf':20,'gc':21,'dif':-1, 'pts':25},
              {'color':0,'shortname':'lota', 'rivalName':'Lota Schwager', 'pj':20, 'pg':2,'pe':6,'pp':12,'gf':28,'gc':52,'dif':-24, 'pts':12},
              {'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':20, 'pg':4,'pe':4,'pp':12,'gf':24,'gc':33,'dif':-9, 'pts':13},
              {'color':0,'shortname':'union', 'rivalName':'U. Española', 'pj':20, 'pg':8,'pe':4,'pp':8,'gf':29,'gc':25,'dif':4, 'pts':28},
              {'color':0,'shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':20, 'pg':8,'pe':3,'pp':9,'gf':30,'gc':38,'dif':-8, 'pts':27},
	      {'color':0,'shortname':'laserena', 'rivalName':'La Serena', 'pj':20, 'pg':7,'pe':5,'pp':8,'gf':31,'gc':30,'dif':1, 'pts':26},
	      {'color':0,'shortname':'everton', 'rivalName':'Everton', 'pj':20, 'pg':6,'pe':8,'pp':6,'gf':24,'gc':27,'dif':-3, 'pts':26},
              {'color':0,'shortname':'palestino', 'rivalName':'Palestino', 'pj':20, 'pg':5,'pe':8,'pp':6,'gf':27,'gc':30,'dif':-3, 'pts':23},
              {'color':0,'shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':20, 'pg':5,'pe':7,'pp':8,'gf':24,'gc':34,'dif':-10, 'pts':22},
	      {'color':0,'shortname':'nublense', 'rivalName':'Ñublense', 'pj':20, 'pg':8,'pe':8,'pp':4,'gf':31,'gc':31,'dif':0, 'pts':32},
	      {'color':0,'shortname':'melipilla', 'rivalName':'Melipilla', 'pj':20, 'pg':8,'pe':4,'pp':8,'gf':35,'gc':34,'dif':1, 'pts':28},
              {'color':0,'shortname':'coquimbo', 'rivalName':'Coquimbo Unido', 'pj':20, 'pg':4,'pe':2,'pp':14,'gf':18,'gc':40,'dif':-22, 'pts':14}]

    };
  }

  componentDidMount() {
		this.getKits();
		let newtable = this.sortTable(this.state.table2);
  		this.setState({table2:newtable});

	}

getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", soc$
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}


  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={4} xl={4} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color} style={{width:'20px'}}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){


  let subT = this.subText('#295e1e', 'Clasificado a Pre-Sudamericana 2007');
  let subC = this.subText('#135683', 'Clasificado a Pre-Sudamericana 2007 y a Libertadores 2008');
  return(

	<div style={{textAlign: 'center' }}>

	 <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Apertura 2007</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>

	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
	<div> * 3 puntos menos a S. Wanderers por no pagar sueldos </div> 
        <div style={{ height: '10px' }}></div>
         {subC}
         {subT}

	
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Apertura 2007</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Apertura 2007</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Apertura 2007" />
     </div>


  )
}

}
export default Apertura2007;
